import { useCallback, useContext } from 'react';
import { useTrackEvent } from '~/context/common/AnalyticsProvider';
import ModalContext from '~/context/srp/ModalContext';

export enum SoftPullLocations {
  Conditional = 'Conditional Tile',
  PriceAndPayment = 'Price and Payment',
  ToolTip = 'Estimate Tool Tip',
  Unlock = 'Unlock Payment CTA',
  Modal = 'More Details Modal CTA'
}

export function useOpenSoftPullModal(location: SoftPullLocations) {
  const { setFilterModalOpen, setSoftPullModalOpen } = useContext(ModalContext);
  const trackEvent = useTrackEvent();

  return useCallback(() => {
    // Close filter modal first so returning from soft-pull doesn't re-fire enter_fullscreen.
    setFilterModalOpen(false);
    setSoftPullModalOpen(true);
    trackEvent('MerchUI Opened Soft Pull Modal', {
      openLocation: location
    });
  }, [location, setFilterModalOpen, setSoftPullModalOpen, trackEvent]);
}
